import axios from "./axiosInstance";

function getPollResults(slug) {
  return axios.get(`/admin/events/${slug}/polls/activeResults`);
}

export default {
  getPollResults,
};
